import { AdminRepository } from "@/domain/repository/admin-repository";
import { SATError, SATResult } from "@sadtx/sat-error";

export class SendPasswordChangeEmailToDoctorUsecase {
  constructor(private readonly adminRepository: AdminRepository) {}

  async execute(doctorUuid: string): Promise<SATResult<void, SATError>> {
    const result = await this.adminRepository.sendPasswordChangeEmail(doctorUuid);
    if (result.isSuccess) {
      return SATResult.success(result.value);
    }

    return SATResult.failure(result.error);
  }
}
